import { useNavigate } from 'react-router-dom';
import { feedUrl, type FeedParams } from '../../lib/feedUrl.js';
import { useTopicLabel } from '../../lib/topics.js';

/** Active filter chips (category / tag / topic); tapping one removes it.
 * `overlay` = floating variant for the full-screen reels layout. */
export default function FilterChips({ params, overlay = false }: { params: FeedParams; overlay?: boolean }) {
  const navigate = useNavigate();
  const topicLabel = useTopicLabel();
  if (!params.category && !params.tag && !params.topic) return null;

  const chip = (label: string, onRemove: () => void, accent = false) => (
    <button
      key={label}
      onClick={onRemove}
      className={`pointer-events-auto min-h-[36px] rounded-full px-3.5 py-1.5 text-xs font-medium backdrop-blur-sm ${
        accent
          ? 'bg-accent/90 text-white'
          : overlay
            ? 'bg-white/90 text-neutral-900'
            : 'bg-neutral-200 text-neutral-800 dark:bg-neutral-800 dark:text-neutral-100'
      }`}
    >
      {label} ✕
    </button>
  );

  return (
    <div
      data-filter-chips
      className={
        overlay
          ? 'pointer-events-none absolute inset-x-0 top-14 z-20 flex gap-1.5 px-3 py-2'
          : 'flex flex-wrap gap-1.5 pb-3'
      }
    >
      {params.category && chip(params.category, () => navigate(feedUrl({ ...params, category: undefined })))}
      {params.tag && chip(`#${params.tag}`, () => navigate(feedUrl({ ...params, tag: undefined })), true)}
      {params.topic && chip(topicLabel(params.topic), () => navigate(feedUrl({ ...params, topic: undefined })))}
    </div>
  );
}
